import { gql } from '@common/hooks';

export const UpdateMembershipStatus = gql`
  mutation UpdateWorksMembershipStatus($id: ID!, $active: Boolean!) {
    updateWorksMembershipStatus(id: $id, active: $active) {
      worksMembership {
        id
        active
      }
    }
  }
`;

export type UpdateMembershipStatus = {
  worksMembership: {
    id: string;
  };
};
